/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import RefundTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import { form, AppendixForm } from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import SelectField from "components/SelectField";
import SoftTypography from "components/SoftTypography";
import Footer from "./components/footer";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaidAmountTable from "./components/paid-amount-table";
import AppendixTable from "./components/appendixTable";
const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};
export default function DNXNLT() {
  const { formId, formField } = form;
  const { formIdAppendix, formFieldAppendix } = AppendixForm;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "02-1/HT", checked: false }]);
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 ? (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Văn bản đề nghị xử lý số tiền thuế, tiền chậm nộp, tiền phạt nộp thừa - 01/DNXLNT
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <RefundTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <PaidAmountTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <MoreFields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />

                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Bảng kê chứng từ nộp thuế - 02-1/HT
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với trường hợp đề nghị hoàn thuế theo hiệp định tránh đánh thuế hai lần
                và Điều ước quốc tế khác/trường hợp tổ chứ,cá nhân thu nhập hoàn thuế TNCN khi quyết
                toán kèm theo giấy đề nghị hoàn trả khoản thu NSNN )
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <AppendixFields
                    formData={{
                      values,
                      touched,
                      formFieldAppendix,
                      errors,
                    }}
                  />
                  <AppendixTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    accountOwner,
    bankAccountNumber,
    bankName,
    certificateNumber,
    chiefAccountant,
    documentNumber,
    signer,
    taxAgentCode,
    taxAgentName,
    taxCode,
    taxPayers,
    timeSign,
    whyRefund,
    sendTo,
  } = formField;
  const [checked, setChecked] = React.useState([true, false]);
  const handleChange1 = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      <FormControlLabel
        label="Hoàn nộp thừa, nộp nhầm tại CQT quản lý trực tiếp/ CQt quản lý khoản thu"
        control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
      />
      <FormControlLabel
        label="Hoàn nộp thừa tại CQT quản lý trực tiếp có khoản thu phân bổ"
        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
      />
      <FormControlLabel
        label="Hoàn nộp thuế GTGT, TNDN tại CQT quản lý địa bàn nơi có công trình xây dựng, hoạt động chuyển nhượng BĐS ngoại tỉnh"
        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
      />
    </Box>
  );
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={sendTo.name}
            label={sendTo.label}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
            <div>
              <FormControlLabel
                label="Tổ chức, cá nhân trả thu nhập hoàn thuế TNCN ủy quyền quyết toán"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
              <FormControlLabel
                label="Hoàn nộp thừa các loại thuế và các khoản thu khác"
                control={
                  <Checkbox
                    checked={checked[0] && checked[1]}
                    indeterminate={checked[0] !== checked[1]}
                    onChange={handleChange1}
                  />
                }
              />
              {children}
              <FormControlLabel
                label="Hoàn trả tiền nộp thừa khi chuyển đổi sở hữu, chuyển đổi doanh nghiệp, sáp nhập, hợp nhất, chia, tách, giải thể,phá sản, chấm dứt hoạt động"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
            </div>
          </Box>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography
              component="div"
              fontSize={13}
              variant="caption"
              fontWeight="bold"
              mb={0.5}
            >
              I - thông tin người nộp thuế
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayers.name}
            label={taxPayers.label}
            value={values.taxPayers}
            error={errors.taxPayers && touched.taxPayers}
            success={values.taxPayers?.toString().length > 0 && !errors.taxPayers}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxCode.name}
            label={taxCode.label}
            value={values.taxCode}
            error={errors.taxCode && touched.taxCode}
            success={values.taxCode?.toString().length > 0 && !errors.taxCode}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentCode.name}
            label={taxAgentCode.label}
            value={values.taxAgentCode}
            error={errors.taxAgentCode && touched.taxAgentCode}
            success={values.taxAgentCode?.toString().length > 0 && !errors.taxAgentCode}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function MoreFields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { accountOwner, bankAccountNumber, bankName, attachDocument } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 30 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="normal" mb={0.5}>
              2. Thông tin người nộp thuế đề nghị hoàn trả khoản thu ngân sách nhà nước
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={accountOwner.name}
            label={accountOwner.label}
            value={values.accountOwner}
            error={errors.accountOwner && touched.accountOwner}
            success={values.accountOwner?.toString().length > 0 && !errors.accountOwner}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={bankAccountNumber.name}
            label={bankAccountNumber.label}
            value={values.bankAccountNumber}
            error={errors.bankAccountNumber && touched.bankAccountNumber}
            success={values.bankAccountNumber?.toString().length > 0 && !errors.bankAccountNumber}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={bankName.name}
            label={bankName.label}
            value={values.bankName}
            error={errors.bankName && touched.bankName}
            success={values.bankName?.toString().length > 0 && !errors.bankName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={attachDocument.name}
            label={attachDocument.label}
            value={values.attachDocument}
            error={errors.attachDocument && touched.attachDocument}
            success={values.attachDocument?.toString().length > 0 && !errors.attachDocument}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function AppendixFields({ formData }) {
  const { formFieldAppendix, values, errors, touched } = formData;
  const { from, to, payerNameAppendix, taxIdAppendix, taxAgentNameAppendix, taxAgentCodeAppendix } =
    formFieldAppendix;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 30 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              [01]. Kỳ đề nghị hoàn thuế
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={from.name}
            label={from.label}
            value={values.from}
            error={errors.from && touched.from}
            success={values.from?.toString().length > 0 && !errors.from}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={to.name}
            label={to.label}
            value={values.to}
            error={errors.to && touched.to}
            success={values.to?.toString().length > 0 && !errors.to}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={payerNameAppendix.name}
            label={payerNameAppendix.label}
            value={payerNameAppendix.to}
            error={errors.payerNameAppendix && touched.payerNameAppendix}
            success={values.payerNameAppendix?.toString().length > 0 && !errors.payerNameAppendix}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxIdAppendix.name}
            label={taxIdAppendix.label}
            value={taxIdAppendix.to}
            error={errors.taxIdAppendix && touched.taxIdAppendix}
            success={values.taxIdAppendix?.toString().length > 0 && !errors.taxIdAppendix}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentNameAppendix.name}
            label={taxAgentNameAppendix.label}
            value={taxAgentNameAppendix.to}
            error={errors.taxAgentNameAppendix && touched.taxAgentNameAppendix}
            success={
              values.taxAgentNameAppendix?.toString().length > 0 && !errors.taxAgentNameAppendix
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentCodeAppendix.name}
            label={taxAgentCodeAppendix.label}
            value={taxAgentCodeAppendix.to}
            error={errors.taxAgentCodeAppendix && touched.taxAgentCodeAppendix}
            success={
              values.taxAgentCodeAppendix?.toString().length > 0 && !errors.taxAgentCodeAppendix
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
